// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Link = function Link(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.81 7.1a3.194 3.194 0 00-2.262-.94H11.5a3.13 3.13 0 01.034.452v.244c0 .1-.005.2-.014.3h1.03a2.217 2.217 0 012.209 2.209V9.6a2.217 2.217 0 01-2.209 2.209H8.613A2.217 2.217 0 016.4 9.6v-.243a2.213 2.213 0 012.137-2.205 2.173 2.173 0 00.023-.316v-.245a2.17 2.17 0 00-.045-.431 3.2 3.2 0 00-3.105 3.2v.24a3.21 3.21 0 003.2 3.2h3.935a3.21 3.21 0 003.2-3.2v-.243A3.194 3.194 0 0014.81 7.1z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M4.484 8.852H3.452a2.217 2.217 0 01-2.209-2.209V6.4a2.217 2.217 0 012.209-2.211h3.935A2.217 2.217 0 019.6 6.4v.244a2.213 2.213 0 01-2.131 2.204 2.166 2.166 0 00-.042.418v.244a2.178 2.178 0 00.026.331 3.206 3.206 0 003.136-3.2V6.4a3.21 3.21 0 00-3.2-3.2H3.452A3.21 3.21 0 00.25 6.4v.244a3.21 3.21 0 003.2 3.2h1.024a3.133 3.133 0 01-.02-.35V9.25a3.088 3.088 0 01.03-.398z"
    }))
  );
};

export default Link;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Link.js
// module id = 1024
// module chunks = 0